import axios from "axios";
import AuthService from "./AuthService";
import { BASE_URL } from "./settings";
import { DEPS_PERCENTIL } from "../constants/depsPercentil";

const URLS = {
  CLASSIFICAR_POR: BASE_URL + "utils/classificar-por",
  EM_ORDEM: BASE_URL + "utils/em-ordem",
  NUMERO_PAGINA: BASE_URL + "utils/numero-pagina",
  RACAS: BASE_URL + "utils/racas",
  GENOTIPADOS: BASE_URL + "utils/genotipados",
  FAZENDAS: BASE_URL + "fazendas",
  CATEGORIAS: BASE_URL + "utils/categorias",
  PAIS: BASE_URL + "utils/pors",
  SITUACOES: BASE_URL + "utils/situacoes",
  SEXOS: BASE_URL + "utils/sexos",
  CENTRAIS: BASE_URL + "utils/centrais",
  VARIEDADES: BASE_URL + "utils/variedades",
  TOPS: BASE_URL + "utils/tops",
  ANIMAIS_PERCENTIL: BASE_URL + "AvaliacaoGenetica/tabela-percentil",
  // Endpoint real exposto pelo AvaliacaoGeneticaController (confirmado no
  // master do Azure DevOps). "ANIMAIS_PERCENTIL" acima ja existia apontando
  // para uma rota que o backend nao tem ("tabela-percentil") - bug preexistente,
  // fora do escopo daqui. Usamos esta constante nova, correta, so para o radar.
  TABELA_PERCENTIL_POR_RACA: BASE_URL + "AvaliacaoGenetica/consultarTabelaPercentilPorRaca",
  AVALIACAO_GENETICA: BASE_URL + "AvaliacaoGenetica/consultarAnimaisAvaliacaoGenetica",
  DETALHES_ANIMAL: BASE_URL + "AvaliacaoGenetica/consultarDetalhesAnimalAvaliacaoGenetica",
  GENEALOGIA: BASE_URL + "AvaliacaoGenetica/genealogia", // ENDPOINT EM TO DO
  // TOTAL: BASE_URL + "AvaliacaoGenetica/filtro-total",
  AG_ATUAL: BASE_URL + "animais/ag-atual/",
  CARACTERISTICAS_POR_RACA: BASE_URL + "AvaliacaoGenetica/caracteristicas",
  CARACTERISTICAS: BASE_URL + "utils/caracteristicas",
  CARACTERISTICAS_AGRUPADAS: BASE_URL + "AvaliacaoGenetica/caracteristicas-agrupadas",
  HELPERS_CARACTERISTICAS: BASE_URL + "Helpers/consultarCaracteristicasAgrupadas",
};

// Acha, num animal retornado pela API, o campo cujo nome corresponde ao
// campoOrdem escolhido na busca (ex: campoOrdem "MGT" -> campo "mgt"),
// ignorando diferenças de maiúscula/minúscula e underscore no nome do
// campo (o JSON do backend varia bastante a capitalização, ex: "d3P",
// "mgtnC_CAR"). Usado para reordenar os resultados de "todas as fazendas"
// pelo mesmo DEP que o usuário escolheu. Mesma lógica usada em Table.js
// para preencher as colunas MGT/Acc/Top.
function getValorCampoOrdem(animal, campoOrdem) {
  if (!animal || !campoOrdem) return undefined;
  const alvo = String(campoOrdem).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
  const chave = Object.keys(animal).find(
    (k) => k.replace(/[^a-zA-Z0-9]/g, "").toLowerCase() === alvo
  );
  return chave !== undefined ? animal[chave] : undefined;
}

export default class AvaliacaoGeneticaService {
  static agAtual = async (racaId) => {
    let url = URLS.AG_ATUAL + racaId;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  // Tabela de percentis por raca (usada para o radar de DEPs na Ficha do Animal -
  // da a referencia "populacao" para comparar contra o animal). Retorna 102 faixas
  // (0.1% a 100%, de 1 em 1) com o valor bruto de cada DEP naquela faixa; usamos
  // a linha 0.1% (melhor) e 100% (pior) para normalizar cada eixo, e a linha 50%
  // (mediana da raca) como referencia de populacao.
  static tabelaPercentilPorRaca = async (idRaca) => {
    let url = URLS.TABELA_PERCENTIL_POR_RACA + "/" + idRaca;

    try {
      const { data } = await axios.get(url);
      return (data && data.data) || [];
    } catch (err) {
      return [];
    } finally {
      // this.setState({ loading: false });
    }
  };

  static classificarPor = async () => {
    let url = URLS.CLASSIFICAR_POR;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static ordem = async () => {
    let url = URLS.EM_ORDEM;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static numeroPagina = async () => {
    let url = URLS.NUMERO_PAGINA;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static numeroPagina = async () => {
    let url = URLS.NUMERO_PAGINA;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static fazendas = async () => {
    let url = URLS.FAZENDAS;

    var token = AuthService.get_token_storage();
    let config = {
      headers: {
        Authorization: `Bearer`,
      },
    };
    if (token) {
      config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      url += "/consultaFazendaPorPerfil";
    }

    try {
      const { data } = await axios.get(url, config);

      if (data && data.data)
        for (let dt of data.data) {
          dt.nomeFantasia = `${dt.idFazenda} - ${dt.nomeFantasia}`
        }

      return data.data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static racas = async () => {
    let url = URLS.RACAS;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static genotipados = async () => {
    let url = URLS.GENOTIPADOS;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static categorias = async () => {
    let url = URLS.CATEGORIAS;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static paises = async () => {
    let url = URLS.PAIS;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    }
  };

  static caracteristicas = async () => {
    let url = URLS.CARACTERISTICAS;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    }
  };

  static caracteristicasDefault = async () => {
    const defaultId = 1;
    return AvaliacaoGeneticaService.caracteristicasPorRaca(defaultId);
  };

  // Bug preexistente corrigido aqui (mesmo padrao do bug da Tabela Percentil):
  // esta funcao chamava URLS.CARACTERISTICAS_POR_RACA ("AvaliacaoGenetica/caracteristicas/{id}"),
  // rota que o backend nao tem - cai no fallback SPA e devolve o HTML da propria
  // pagina como string. Como "response.length > 0" e verdadeiro pra qualquer string
  // nao vazia, essa string HTML era guardada como se fosse a lista de DEPs, e o
  // .map() feito em cima dela (em FormExportarExcel/FormExportarPag, tela "DEPS")
  // quebrava com TypeError, pois strings nao tem .map(). Ou seja: as abas
  // "Exportar Excel" e "Exportar MAX PAG" quebravam sempre que havia resultado de
  // busca.
  //
  // A rota real e "AvaliacaoGenetica/caracteristicas-agrupadas/{racaId}" (mesma
  // usada por caracteristicasAgrupadas() acima), so que ela devolve os dados
  // agrupados por "grupo" (ex: [{ grupo: "Crescimento", caracteristicas: [{ nome, id }] }]),
  // formato diferente do que essas telas esperam (uma lista simples de
  // { caracteristicaId, caracteristicaDescricao }). Achatamos o agrupamento aqui.
  static caracteristicasPorRaca = async (racaId) => {
    let url = URLS.CARACTERISTICAS_AGRUPADAS + `/${racaId}`;

    try {
      const { data } = await axios.get(url);
      if (!Array.isArray(data)) return [];

      const lista = [];
      data.forEach((grupo) => {
        if (grupo && Array.isArray(grupo.caracteristicas)) {
          grupo.caracteristicas.forEach((c) => {
            lista.push({
              id: c.id,
              caracteristicaId: c.id,
              caracteristicaDescricao: c.nome,
              grupo: grupo.grupo,
            });
          });
        }
      });

      return lista;
    } catch (err) {
      return [];
    }
  };

  static caracteristicasAgrupadas = async (racaId) => {
    let url = URLS.CARACTERISTICAS_AGRUPADAS + `/${racaId}`;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    }
  };

  static sexos = async () => {
    let url = URLS.SEXOS;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static situacoesAnimal = async () => {
    let url = URLS.SITUACOES;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static variedades = async () => {
    let url = URLS.VARIEDADES;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static centrais = async () => {
    let url = URLS.CENTRAIS;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static tops = async () => {
    let url = URLS.TOPS;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  // Bug preexistente corrigido aqui: esta funcao chamava URLS.ANIMAIS_PERCENTIL
  // ("AvaliacaoGenetica/tabela-percentil"), uma rota que o backend nao tem (cai
  // no fallback SPA e devolve HTML, nunca dados) - por isso a aba "Tabela
  // Percentil" nunca funcionou. A rota real e "consultarTabelaPercentilPorRaca"
  // (ver AvaliacaoGeneticaService.tabelaPercentilPorRaca, e AvaliacaoGeneticaController
  // no master do Azure DevOps). Ela devolve 102 linhas (uma por faixa de 0.1%
  // a 100%) com o valor bruto de cada DEP - pivotamos aqui para o formato que
  // TablePercentil.js espera: uma coluna por DEP, com um valor por linha na
  // MESMA ordem (0.1%, 0.5%, 1%, 2%, 3%, ..., 100%) para todas as colunas.
  static animaisPercentil = async (idRaca) => {
    const linhas = await AvaliacaoGeneticaService.tabelaPercentilPorRaca(idRaca);

    if (!Array.isArray(linhas) || linhas.length === 0) return [];

    return DEPS_PERCENTIL.map((dep) => ({
      caracteristica: dep.label,
      valores: linhas.map((linha) => ({
        top: linha.top,
        valor: linha[dep.percentil] !== undefined && linha[dep.percentil] !== null
          ? linha[dep.percentil]
          : "",
      })),
    }));
  };

  static animaisFiltrados = async (value) => {
    let url = URLS.AVALIACAO_GENETICA;

    try {
      const { data } = await axios.post(url, value);
      return data;
    } catch (err) {
      throw err.response.data;
    } finally {
      // this.setState({ loading: false });
    }
  };

  // Busca numa unica fazenda, sem lancar excecao em erro (usada pela busca
  // "todas as fazendas" abaixo - um erro numa fazenda nao pode derrubar as
  // outras 17). AnimaisPorPagina fixo em 500: e o teto que o backend aceita
  // por chamada (testado direto contra a API - pedir mais que isso nao traz
  // mais resultados), entao buscamos o maximo permitido de cada fazenda de
  // uma vez so.
  static animaisFiltradosPorFazenda = async (idFazenda, filtros) => {
    let url = URLS.AVALIACAO_GENETICA;
    const body = { ...filtros, idFazenda: String(idFazenda), AnimaisPorPagina: "500", Page: 1 };

    try {
      const { data } = await axios.post(url, body);
      return Array.isArray(data && data.data) ? data.data : [];
    } catch (err) {
      return [];
    }
  };

  // Bug preexistente contornado aqui: o backend exige IdFazenda (campo
  // [Required] em AnimaisFiltradosAvaliacaoGeneticaRequisicao.cs, validado
  // automaticamente pelo ASP.NET Core ANTES de qualquer logica de negocio
  // rodar) - nao tem como pedir "todas as fazendas" numa unica chamada ao
  // backend sem mudar o DTO la. Como alternativa 100% frontend, quando o
  // usuario nao escolhe uma fazenda, buscamos em paralelo em cada fazenda
  // que ele tem acesso (mesma lista do dropdown "Fazenda") e juntamos tudo
  // aqui, reordenando pelo mesmo campo/direcao pedidos (campoOrdem/Ordem).
  //
  // Bug preexistente CORRIGIDO aqui (achado ao investigar por que MGT/Acc/Top
  // vinham em branco na tabela): esse sort tentava ler "a.valor"/"b.valor",
  // mas o backend nunca devolveu um campo generico "valor" - confirmado
  // direto contra a API. Cada DEP tem seu proprio campo no retorno, com o
  // MESMO NOME do campoOrdem escolhido (ex: campoOrdem "MGT" -> campo "mgt"
  // no JSON, com o valor real, tipo 31.2). getValorCampoOrdem abaixo acha
  // esse campo dinamicamente pelo nome (ignorando maiuscula/minuscula),
  // igual ao que foi corrigido em Table.js.
  static animaisFiltradosTodasFazendas = async (fazendas, filtros) => {
    const listas = await Promise.all(
      (Array.isArray(fazendas) ? fazendas : []).map((f) =>
        AvaliacaoGeneticaService.animaisFiltradosPorFazenda(f.idFazenda, filtros)
      )
    );

    const todos = listas.flat();
    const decrescente = String(filtros.Ordem || "DESC").toUpperCase() !== "ASC";
    const campoOrdem = filtros && filtros.campoOrdem;

    todos.sort((a, b) => {
      const va = parseFloat(getValorCampoOrdem(a, campoOrdem));
      const vb = parseFloat(getValorCampoOrdem(b, campoOrdem));
      const naoNumA = Number.isNaN(va);
      const naoNumB = Number.isNaN(vb);
      if (naoNumA && naoNumB) return 0;
      if (naoNumA) return 1;
      if (naoNumB) return -1;
      return decrescente ? vb - va : va - vb;
    });

    return todos;
  };

  static genealogia = async (value) => {
    let url = URLS.DETALHES_ANIMAL + "/" + value;

    try {
      const { data } = await axios.get(url);

      return data.genealogia;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static detalhesAnimal = async (value) => {
    let url = URLS.DETALHES_ANIMAL + "/" + value;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  static helpersCaracteristicas = async (value, cga, idRaca) => {
    const config = {
      headers: {
        Authorization: `Bearer`,
      },
    }

    // O backend atual exige cga e idRaca como query params (alem do corpo com
    // as caracteristicas). Sem eles, o endpoint gera uma query SQL invalida
    // (WHERE a.CGA IN () vazio) e retorna 400 - por isso sempre repassamos os
    // dois valores aqui.
    let url = `${URLS.HELPERS_CARACTERISTICAS}?cga=${encodeURIComponent(cga || "")}&idRaca=${idRaca || 0}`

    try {
      const { data } = await axios.post(url, value, config);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };

  // static total = async (value) => {
  //   let url = URLS.TOTAL;

  //   try {
  //     const { data } = await axios.post(url, value);
  //     return data.data;
  //   } catch (err) {
  //     return err;
  //   } finally {
  //     // this.setState({ loading: false });
  //   }
  // };
}
